import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ScrollingText = {
	$section: null,

	init: function() {
		this.$section = document.querySelector('.js-scrolling-text');
		if (!this.$section) return;
		this.setup();
	},

	setup: function() {
		const section = this.$section;
		const band = section.querySelector('.js-scrolling-text-band');
		if (!band) return;

		const run = () => {
			const bandWidth = band.scrollWidth;
			const vw = window.innerWidth;

			// Band starts at x=0 (left-flush, text already visible, gradient fills viewport).
			// Ends when right edge of band aligns with right edge of viewport.
			gsap.fromTo(band,
				{x: 0},
				{
					x: -(bandWidth - vw),
					ease: 'none',
					scrollTrigger: {
						trigger: section,
						start: 'top bottom',
						end: 'bottom top',
						scrub: 1,
					},
				}
			);
		};

		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(run);
		} else {
			run();
		}
	},
};

export default ScrollingText;
